import { render } from "./carousel-header-media-modal.vue?vue&type=template&id=2f647fa1&scoped=true"
import script from "./carousel-header-media-modal.vue?vue&type=script&lang=js"
export * from "./carousel-header-media-modal.vue?vue&type=script&lang=js"

import "./carousel-header-media-modal.vue?vue&type=style&index=0&id=2f647fa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f647fa1"]])

export default __exports__